module.exports = __webpack_public_path__ + "static/media/testimonial-8.6fd0a4e3.png";